// extracted by mini-css-extract-plugin
export default {"page-login":"index_page-login__YByz9"};